import { termosStep } from '../../shared/termosSections';
import { identificacaoSociedadeSection } from '../../shared/sociedadeSections';
import { enderecoComercialStep, DADOS_REQUERIMENTO_ENDERECO_PROFISSIONAL } from '../../shared/enderecoSections';
import { CAMPOS_ASSOCIACAO_SOCIEDADES, CERTIDAO_REGULARIDADE_OUTRA_SECCIONAL, PAGAMENTO_POR_SOCIEDADE } from '../../shared/associacaoSociedadesSections';

const pedidoDistratoAssociacaoSociedadesConfig = {
  id: 'pedido_distrato_associacao_sociedades',
  nome: 'Pedido de Distrato de Associação entre Sociedades de Advogados',
  descricao: 'Solicitação de registro do distrato de associação entre sociedades de advogados',
  icon: 'FaFileContract',
  categoria: 'sociedades',

  documentConfig: {
    required: [
      { id: 'requerimento', tipoDocumentoProcesso: 433, name: 'Requerimento', description: 'Requerimento preenchido e assinado digitalmente', required: true },
      { id: 'contratoDistrato', tipoDocumentoProcesso: 540, name: 'Contrato de Distrato', description: 'Contrato de distrato da associação entre as sociedades', required: true }
    ],
    conditional: [CERTIDAO_REGULARIDADE_OUTRA_SECCIONAL]
  },

  paymentConfig: PAGAMENTO_POR_SOCIEDADE,

  protocoloConfig: {
    modeloRequerimento: '327',
    tiposAssunto: '846',
    tipoPedido: '520'
  },

  // Endereço comercial completo da sociedade (grupo "Comercial" da API).
  dadosRequerimentoConfig: DADOS_REQUERIMENTO_ENDERECO_PROFISSIONAL,

  tituloConfig: {
    tipoLancamentoId: 160,
    enderecoOrigem: 'comercial'
  },

  steps: [
    {
      id: 'dados_sociedade',
      title: 'Dados da Sociedade',
      sections: [
        identificacaoSociedadeSection(CAMPOS_ASSOCIACAO_SOCIEDADES)
      ]
    },
    // Endereço comercial completo (CEP, logradouro, número, complemento, bairro,
    // município, UF, telefone, celular e e-mail), em vez do endereço enxuto dos
    // demais pedidos de Sociedade.
    enderecoComercialStep({ autoCep: true, id: 'endereco' }),
    termosStep()
  ]
};

export default pedidoDistratoAssociacaoSociedadesConfig;
